import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AsideService {
  enabled = false;

  host = environment.host;
  api = environment.apiUrl;
  request;
  resource;
  params;
  model;
  response;

  toggle() {
    this.enabled = !this.enabled;
  }
}
